import React from 'react';
import DoctorLayout from '../doctor/DoctorLayout';
import { DENTIST_PATHS } from '../doctor/doctorPaths';

/** Espace clinique dentaire dédié (séparé du portail médecin). */
export default function DentistLayout() {
  return <DoctorLayout portalPaths={DENTIST_PATHS} forceDentist />;
}
